import React, { useEffect } from "react";

import { blockedApi, BlockedApi } from "api/blockedApi";
import { useBlocked } from "api/hooks";
import { AdminResourceDeleteModal, AdminSearchInput, FiltersBackground, PageHeader, PageMain } from "components/molecules";
import { TanTable, TanTableColumn, useFilters, usePagination, useSorting } from "components/molecules";
import { useDeleteResourceActions } from "utils/store";

const BLOCKED_TYPE_NAME: Record<number, string> = {
  1: "Email",
  2: "PESEL",
};

export const BlockedPage = (): JSX.Element => {
  const { setDeleteResource } = useDeleteResourceActions();

  const { searchPhrase, setSearchPhrase } = useFilters();
  const { limit, skip, onPaginationChange, pagination } = usePagination();
  const { sorting, onSortingChange, fieldWithOrder } = useSorting();
  const { isLoading, isFetching, blocked, total, invalidate } = useBlocked(skip, limit, searchPhrase);

  useEffect(() => {
    invalidate();
  }, [sorting, pagination, searchPhrase]);

  const columns = React.useMemo<TanTableColumn<BlockedApi>[]>(() => cols, []);

  return (
    <PageMain>
      <PageHeader>Zablokowani użytkownicy</PageHeader>
      <FiltersBackground className="mb-4">
        <div className="flex flex-wrap items-center gap-2">
          <AdminSearchInput onSearch={(sp) => setSearchPhrase(sp)} className="mt-2 self-end" />
        </div>
      </FiltersBackground>
      <TanTable
        data={blocked}
        columns={columns}
        loading={isLoading}
        fetching={isFetching}
        total={total}
        onPaginationChange={onPaginationChange}
        onSortingChange={onSortingChange}
        pagination={pagination}
        sorting={sorting}
        onDelete={(x) => setDeleteResource(x.id)}
      />
      <AdminResourceDeleteModal
        title="Odblokuj użytkownika"
        description="Jesteś pewien że chcesz odblokować tego użytkownika?"
        onSuccessDelete={() => invalidate()}
        deleteAction={blockedApi.delete}
      />
    </PageMain>
  );
};

const cols: TanTableColumn<BlockedApi>[] = [
  {
    id: "id",
    hideOnMobile: true,
    accessorKey: "id",
    header: "ID",
    enableColumnFilter: false,
    size: 10,
  },
  {
    id: "identifier",
    accessorKey: "identifier",
    header: "Identyfikator",
    enableColumnFilter: false,
  },
  {
    id: "type",
    accessorKey: "type",
    header: "Typ",
    enableColumnFilter: false,
    cell: (info) => BLOCKED_TYPE_NAME[info.row.original.type] ?? info.row.original.type,
  },
  {
    id: "reason",
    hideOnMobile: true,
    accessorKey: "reason",
    header: "Powód",
    enableColumnFilter: false,
  },
];
